import { AlertTitle, Collapse, FormLabel, Stack } from "@mui/material"
import { ReactElement, useContext, useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"

import { IUpload } from "../../../../services/middleware/types/singleApplication/uploadAttachmentTypes"
import AppAlert from "../../../dataDisplay/alerts/appAlert"
import { ApplicationContext } from "../applicationProvider"
import SingleApplicationDropzone from "../recognisedForms/singleApplicationDropzone"

// TODO - auto-extract file URL key
// TODO - prevent submissions when nothing entered
// Handle minimum items
// Handle initial values
const MAX_ITEMS = 1 // As single attachment

interface ISingleAttachmentInputProps {
    title: string
    registerName: string
    fileUrlKey: string
    initialUploads?: IUpload[]
    programmaticallySetForm: (key: string, value: any) => void
}

/** Enables user to upload a single attach object as part of a key value
 * entry in a form
 */
const SingleAttachmentInput = ({
    title,
    registerName,
    initialUploads = [],
    fileUrlKey,
    programmaticallySetForm,
}: ISingleAttachmentInputProps): ReactElement => {
    const [uploads, setUploads] = useState<IUpload[]>(initialUploads)
    const [displayError, setDisplayError] = useState(false)
    const { setSupplementingInfo } = useContext(ApplicationContext)

    const { register: registerFunc, unregister } = useFormContext()

    const uploadSideEffects = (newStuff: IUpload[]): void => {
        setDisplayError(false)
        programmaticallySetForm(registerName, {
            [fileUrlKey]: newStuff[0]?.fileUrl ?? undefined,
        })
        setSupplementingInfo((prev) => ({
            ...prev,
            ...{ [registerName]: newStuff },
        }))
    }

    useEffect(() => {
        registerFunc(registerName, { required: true })

        return () => {
            unregister(registerName)
        }
    }, [registerFunc, registerName])

    return (
        <>
            <Stack spacing={0.1}>
                <FormLabel>{title}</FormLabel>
                <SingleApplicationDropzone
                    uploads={uploads}
                    setUploads={setUploads}
                    imageMode={false}
                    uploadSideEffects={uploadSideEffects}
                    maxPerDrop={MAX_ITEMS}
                />
            </Stack>
            <Collapse in={displayError && uploads.length >= MAX_ITEMS}>
                <AppAlert severity="warning">
                    <AlertTitle>
                        {`You can only upload a maximum of ${MAX_ITEMS} file`}
                    </AlertTitle>
                </AppAlert>
            </Collapse>
        </>
    )
}

SingleAttachmentInput.defaultProps = {
    initialUploads: [],
}

export default SingleAttachmentInput
